import React, { useEffect } from "react";
import "./styles.css";
import LayoutCore from "./pages/LayoutCore";
import Login from "./pages/Login";
import CadastroRevendedor from "./pages/CadastroRevendedor";
import HomeApp from "./pages/HomeApp";
import LogoffApp from "./pages/LogoffApp";
import KitsList from "./pages/KitsList";
import VendasList from "./pages/VendasList";
import ClienteVendasList from "./pages/ClienteVendasList";
import UsersList from "./pages/UsersList";
import UsersDetail from "./pages/UsersDetail";
import UserCreate from "./pages/UserCreate";
import VendaDetail from "./pages/VendaDetail";
import CustomerDetail from "./pages/CustomerDetail";
import Products from "./pages/Products";
import Customers from "./pages/Customers";
import ProductDetail from "./pages/ProductDetail";
import NovaVenda from "./pages/NovaVenda";
import Fechamento from "./pages/Fechamento";
import Aplicativo from "./pages/Aplicativo";
import Profile from "./pages/Profile";
import RequestResetPass from "./pages/RequestResetPass";

import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import $ from "jquery";
import jQuery from "jquery";
import UsersChangePass from "./pages/UsersChangePass";
import Pagamentos from "./pages/Pagamentos";
import PagamentosList from "./pages/PagamentosList";
import FichaList from "./pages/FichaList";
import PreCadastroList from "./pages/PreCadastroList";
import KitItens from "./pages/KitItens";
import BillsToReceive from "./pages/billsToReceive/BillsToReceive";
import Ficha from "./pages/Ficha";
import PreCadastro from "./pages/PreCadastro";
import LayoutApp from "./pages/Layout/LayoutApp";

window.$ = jQuery;

function App() {
  let { location } = window;

  useEffect(() => {
    $(document).ready(function () {
      try {
        $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
          if (
            location.pathname.replace(/^\//, "") ===
              this.pathname.replace(/^\//, "") &&
            location.hostname === this.hostname
          ) {
            var target = $(this.hash);
            target = target.length
              ? target
              : $("[name=" + this.hash.slice(1) + "]");
            if (target.length) {
              $("html, body").animate(
                {
                  scrollTop: target.offset()?.top - 72,
                },
                1000,
                "easeInOutExpo"
              );
              return false;
            }
          }
        });

        // Closes responsive menu when a scroll trigger link is clicked
        $(".js-scroll-trigger").click(function () {
          $(".navbar-collapse").collapse("hide");
        });

        // $("navbar-toggler-right").click(function(){

        // });

        // Collapse Navbar
        var navbarCollapse = function () {
          if ($("#mainNav").offset()?.top > 100) {
            $("#mainNav").addClass("navbar-scrolled");
          } else {
            $("#mainNav").removeClass("navbar-scrolled");
          }
        };
        // Collapse now if page is not at top
        navbarCollapse();
        // Collapse the navbar when page is scrolled
        $(window).scroll(navbarCollapse);
      } catch (error) {}
    });
  }, [location.hostname, location.pathname]);

  return (
    <div>
      <ToastContainer />
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Login/>}></Route>
          <Route exact path="/login" element={<Login/>}></Route>
          <Route exact path="/sobre" element={<LayoutCore/>}></Route>
          <Route exact path="/revenda" element={<CadastroRevendedor/>}></Route>
          <Route exact path="/catalogo" element={<LayoutCore/>}></Route>
          <Route exact path="/contato" element={<LayoutCore/>}></Route>

          <Route exact path="/app" element={<HomeApp/>}></Route>
          <Route exact path="/sair" element={<LogoffApp/>}></Route>
          <Route exact path="/venda/nova" element={<NovaVenda/>}></Route>
          <Route exact path="/kits" element={<KitsList/>}></Route>
          <Route exact path="/kit/:id" element={<KitItens/>}></Route>
          <Route
            exact
            path="/venda/cliente/:id"
            element={<ClienteVendasList/>}
          ></Route>
          <Route exact path="/users" element={<UsersList/>}></Route>
          <Route exact path="/users/:id" element={<UsersDetail/>}></Route>
          <Route exact path="/user/create" element={<UserCreate/>}></Route>
          <Route exact path="/produtos" element={<Products/>}></Route>
          <Route exact path="/pagamentos" element={<Pagamentos/>}></Route>
          <Route exact path="/ficha" element={<FichaList/>}></Route>
          <Route exact path="/pre-cadastro" element={<PreCadastroList/>}></Route>
          <Route exact path="/pagamentos/list" element={<PagamentosList/>}></Route>
          <Route exact path="/profile" element={<Profile/>}></Route>
          <Route exact path="/produto/:id" element={<ProductDetail/>}></Route>
          <Route exact path="/clientes" element={<Customers/>}></Route>
          <Route exact path="/fechamento" element={<Fechamento/>}></Route>
          <Route exact path="/aplicativo" element={<Aplicativo/>}></Route>
          <Route exact path="/cliente/:id" element={<CustomerDetail/>}></Route>
          <Route exact path="/contas" element={<BillsToReceive/>}></Route>
          
          <Route exact path="vendas" element={<VendasList/>} />
          <Route exact path="/venda/:id" element={<VendaDetail/>}></Route>

          <Route
            exact
            path="/request/reset-pass"
            element={<RequestResetPass/>}
          ></Route>
          <Route exact path="/new-pass" element={<UsersChangePass/>}></Route>

          <Route path='app' element={<LayoutApp />}>
            <Route path="ficha/add" element={<Ficha />} />
            <Route path="ficha/:id" element={<Ficha />} />
            <Route path="pre-cadastro/add" element={<PreCadastro />} />
            <Route path="pre-cadastro/:id" element={<PreCadastro />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
